import { createFeatureSelector, createSelector } from '@ngrx/store';
import { WorkflowState } from '../reducers/workflow.reducer';

export const workflowState: any = createFeatureSelector<WorkflowState>('workflow');

export const workflowData = createSelector(workflowState, (state: any) => {
  return state.workflowData;
});

export const workflowDT = createSelector(workflowState, (state: any) => {
  return state.workflowDT;
});

export const wfActors = createSelector(workflowState, (state: any) => {
  return state.wfActors;
});

export const wfActions = createSelector(workflowState, (state: any) => {
  return state.wfActions;
});

export const dynamicPossibleOptions = createSelector(workflowState, (state: any) => {
  return state.dynamicPossibleOptions;
});
export const dynamicPossibleOptionsForHide = createSelector(workflowState, (state: any) => {
  return state.dynamicPossibleOptionsForHide;
});

export const workflows = createSelector(workflowState, (state: any) => {
  return state.workflows;
});

export const workflowMail = createSelector(workflowState, (state: any) => {
  return state.workflowMail;
});

export const workflowOrderSuccess = createSelector(workflowState, (state: any) => {
  return state.results;
});

export const workflowOrderFailure = createSelector(workflowState, (state: any) => {
  return state.error;
});
